import Home from "@arcgis/core/widgets/Home";
export function HomeWidget(settings) {
    let homeWidget = new Home({
        view: settings.view
    });
    settings.view.ui.add(homeWidget, settings.widgetPosition);
}
